module.exports = __webpack_public_path__ + "static/media/user.bc2d69bf.svg";